import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBox2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"box-2, inbox, archive, tray, shelf"} maskId="square-filled-radius-0-stroke-1-IconBox2"><path d="M21 13L21 21H3L3.00003 13H7.61151C8.06624 15.004 9.85841 16.5 12 16.5C14.1416 16.5 15.9338 15.004 16.3885 13L21 13Z" fill="currentColor"/><path d="M21 12L21 3L3.00005 3.00001L3.00003 12H8.50001V12.0072C8.50387 13.9369 10.0694 15.5 12 15.5C13.933 15.5 15.5 13.933 15.5 12L21 12Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBox2;
